import React from "react";
import { benefitItemsMap } from "../../configs/benefits";
import BenefitItem from "./BenefitItem";

const BenefitsBox = () => {
  return (
    <div id="advertise-box">
      <div className="box-header">
        <span>Benefits Of Using EasyDuct</span>
        <span>Advertising</span>
      </div>
      <div className="grid grid-cols-2 gap-10 mt-16 lg:gap-5 lg:grid-cols-4">
        {benefitItemsMap.map((benefit, index) => (
          <div key={index} className="">
            <BenefitItem item={benefit} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsBox;
